<template>
  <div v-if="loaded">
    <element-renderer
      v-for="elementId in childElements"
      v-show="!getElementById(elementId)?.layerHiddenInGraphics"
      :id="elementId"
      :key="elementId"
      :type="getElementValueByProp(elementId, 'type')"
      :parent="id"
      :toggle="toggle"
      @select="(e, id) => $emit('select', e, id)"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';
import elementsMixins from '../../../mixins/elements-mixins';
import sheetsDataModule from '../../../store/modules/sheetsData';

import catchify from 'catchify';

export default {
  emits: ['select'],
  name: 'GoogleSheetsElement',
  components: {
    ElementRenderer: defineAsyncComponent(() => import('../ElementRenderer')),
  },
  mixins: [elementsMixins],
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    childElements() {
      return this.getElementGroupMap[this.id] || [];
    },
  },
  created() {
    // Setup store module for storing sheet data for this provider
    if (!this.$store.state?.[this.element.id]) {
      this.$store.registerModule(this.element.id, sheetsDataModule);

      // Resync spreadsheet
      // TODO: Instead of re-syncing, we should load the sheet data from the API
      this.sync();
    } else {
      this.loaded = true;
    }
  },

  methods: {
    ...mapActions({
      getPrivateSheetData(dispatch, payload) {
        return dispatch(`${this.element.id}/getPrivateSheetData`, payload);
      },

      getPublicSheetData(dispatch, payload) {
        return dispatch(`${this.element.id}/getPublicSheetData`, payload);
      },
    }),

    async sync() {
      this.loaded = false;
      const {
        url, sheet, accountId, workbookId, sheetId,
      } = this.element.data;

      if (!url && !accountId) {
        this.loaded = true;
        return;
      }

      let err = null;
      if (accountId) {
        // Fetch private sheet
        [err] = await catchify(
          this.getPrivateSheetData({
            workbookId,
            accountId,
            sheetId,
          }),
        );
      } else if (url) {
        // Fetch public sheet
        [err] = await catchify(
          this.getPublicSheetData({
            key: this.element.id,
            url,
            sheet,
          }),
        );
      }

      if (err) {
        // eslint-disable-next-line no-console
        console.log('Error prefetching data:', err);
      }
      this.loaded = true;
    },
  },
};
</script>
